import { useEffect, useState } from 'react';

/**
 * After the initial render, provide the hostname.
 */
const useHostname = () => {
  const [hostname, setHostname] = useState('');

  // This will run once after initial render.
  useEffect(() => {
    setHostname(
      window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '')
    );
  }, []);

  return hostname;
};

export default useHostname;
